import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CurrentUser } from '../current-user.model';
import { CurrentUserService } from "../current-user.service";

@Component({
  selector: 'auth-fail-dialog',
  templateUrl: 'auth-fail-dialog.component.html',
  styleUrls: ['auth-fail-dialog.component.css']
})
export class AuthFailDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<AuthFailDialogComponent>,
    private currentUserService: CurrentUserService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/security/auth-fail-dialog/auth-fail-dialog.component.ts